import React from 'react';
import './styles.css';

const HoldingsTabs = ({ tabs, activeTab, setActiveTab }) => {
    const tabLabelsMap = {
        securities: "Securities",
        asset_class: "Asset Class",
        investment_category: "Investment Category",
        investment_type: "Investment Type",
        global: "Global"
    }
    
    const activeStyle = tab => (activeTab === tab ? {
        position: 'relative',
        border: '1px solid #bfbfbf',
        borderBottom: '1px solid #fff',
        zIndex: 9999
    } : {})

    return (
        <div className='holding-tabs-container' style={{ position: 'relative', top: '1px', display: "flex", overflow: 'auto' }}>
            {tabs.map((tab) => {
                return (
                    <div 
                        key={tab} 
                        onClick={() => setActiveTab(tab)}
                        className='holding-tabs'
                        style={activeStyle(tab)}
                    >
                        {tabLabelsMap[tab]}
                    </div>
                )
            })}
        </div>
    )
}

export default HoldingsTabs